const MOBILEREG = /^[0]?[123456789]\d{9}$/;

export const MobileValidate = {
    getMessage(field, args) {
        return 'phone is wrong';
    },
    validate(value, args) {
        return MOBILEREG.test(value);
    }
};